import { AxiosPromise } from 'axios';
import {
    Template,
    TemplateList,
    TemplateScopeType,
    TemplateType,
    TemplateOrder,
    TagType,
    TemplateTagList,
} from '@dev/ee-api/ee-api-models';
import { request } from './request';

export const loadTemplate = (name: string, isPublic: boolean, templateType?: TemplateType): Promise<Template> => {
    const { Templates } = request();
    return Templates.templatesByNameGet(name, isPublic, templateType).then((resp): Template => resp.data);
};

export const saveTemplate = (template: Template): Promise<Template> => {
    const { Templates } = request();

    return Templates.templatesPost(template).then((resp): Template => resp.data);
};

export const copyTemplate = (name: string, changes: Template): Promise<Template> => {
    const { Templates } = request();
    return Templates.templatesByNameCopyPost(name, changes).then((resp): Template => resp.data);
};

export const updateTemplate = (
    templateName: string,
    template: Template,
    removeScreenshot?: boolean
): Promise<Template> => {
    const { Templates } = request();

    return Templates.templatesByNamePut(templateName, template, removeScreenshot).then((resp): Template => resp.data);
};

export interface TemplateListParams {
    type?: TemplateScopeType[];
    search?: string;
    tags?: string[];
    templateTypes?: TemplateType[];
    limit?: number;
    offset?: number;
    options?: any;
    templateOrder?: TemplateOrder;
}

export const loadTemplateList = (params: TemplateListParams): Promise<TemplateList> => {
    const { Templates } = request();

    return Templates.templatesGet(
        params.type,
        params.search ? params.search : undefined,
        params.tags,
        params.templateTypes,
        params.limit,
        params.offset,
        params.templateOrder
    ).then((resp): TemplateList => resp.data);
};
export const previewTemplate = (name: string, ispublic?: boolean,templateType?: TemplateType): Promise<string> => {
    const { Templates } = request();

    if (!ispublic && window.location.hash.includes('/public/')) {
        ispublic = true;
    }
    return Templates.templatesByNamePreviewGet(name, ispublic,templateType).then((resp) => resp.data);
};
export const downloadTemplate = (name: string): AxiosPromise<any> => {
    const { Templates } = request();
    return Templates.templatesByNameDownloadGet(name);
};
export const loadTemplatesTags = (type: TagType): Promise<TemplateTagList> => {
    const { Templates } = request();
    return Templates.templatesTagsGet(type).then((resp): TemplateTagList => resp.data);
};
export const deleteTemplate = (name: string): Promise<void> => {
    const { Templates } = request();

    return Templates.templatesByNameDelete(name).then((resp): void => {
        resp.data;
    });
};
export const templatesTagsDelete = (name: string, type: TagType): Promise<void> => {
    const { Templates } = request();
    return Templates.templatesTagsByNameDelete(name, type).then((resp): void => resp.data);
};
export const deleteTemplateArray = (templates: string[]): Promise<void> => {
    const { Templates } = request();

    return Templates.templatesDeleterequestsPost(templates).then((resp): void => resp.data);
};
export const getDefaultTemplateObj = (templateType: TemplateType): AxiosPromise<Template> => {
    const { Templates } = request();
    return Templates.templatesDefaultGet(templateType);
};

export const shareTemplate = (name: string): AxiosPromise<string> => {
    const { Templates } = request();
    return Templates.templatesByNameShareGet(name);
};

export const createSharedTemplate = (share: string): AxiosPromise<Template> => {
    const { Templates } = request();
    return Templates.templatesByShareSharecopyPost(share);
};
